import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Img from 'gatsby-image'
import Facebook from 'mdi-material-ui/Facebook'
import Twitter from 'mdi-material-ui/Twitter'
import Youtube from 'mdi-material-ui/Youtube'
import Linkedin from 'mdi-material-ui/Linkedin'


class SingleTemplate extends React.Component {
    render() {
    var imgs = this.props.imgs;
	const post = this.props.data.markdownRemark
	const siteTitle = get(this.props, 'data.site.siteMetadata.title')
	let meta = [{property: 'description',
		     content: post.frontmatter.description},
		    {property: 'og:url',
		     content: "https://sharemeals.org" + this.props.location.pathname},
		    {property: 'og:description',
		     content: post.excerpt},
		    {property: 'og:title',
		     content: post.frontmatter.title}];
	// TODO: add feature image to meta tags

console.log(post.frontmatter)
	return (
	    <div style={this.props.transition && this.props.transition.style}>
			<Grid>
			    <Helmet
				title={`${post.frontmatter.title} | ${siteTitle}`}
				meta={meta} />
			    <Row>
				<Col xs={12} lg={10} lgOffset={1} xl={8} xlOffset={2}>
				    <Card className="card white">
					<CardContent>
				    <h1 className="page-title">{post.frontmatter.title}</h1>
				    <p className="byline">
					{post.frontmatter.date}
				    </p>
				    <div dangerouslySetInnerHTML={{ __html: post.html }} />
					</CardContent>
				    </Card>
				</Col>
			    </Row>
			</Grid>
	    </div>
	)
    }
}

export default SingleTemplate

export const pageQuery = graphql`
    query SingleBySlug($slug: String!) {
	site {
	    siteMetadata {
		title
	    }
	}
	markdownRemark(fields: { slug: { eq: $slug } }) {
	    html
	    excerpt
	    frontmatter {
		title
		subtitle
		date(formatString: "MMMM D, YYYY")
	    }
	}
    }
`



// WEBPACK FOOTER //
// ./src/templates/single.js